// sample events
export enum EventType {
  LeadCreated = 'LeadCreated',
  SubmissionStarted = 'SubmissionStarted',
}
